import LoginForm from './login-form';
import { withStyles } from '@material-ui/core';
import styles from './login-form.styles';

export * from './login-form';
export { default as UpdatePassForm } from './update-pass-form';
export default withStyles(styles)(LoginForm);
